module.exports = __webpack_public_path__ + "img/8.cadb639f.png";